module.exports = __webpack_public_path__ + "static/media/bg_muba.5a166a7d.jpg";